import { Inject, Injectable, Injector } from '@angular/core';



@Injectable({ providedIn: 'root' })
export class Discussions_ReportService {

  constructor(
    private injector: Injector
  ) {
  }

  public Discussions: Discussions_ReportService = this;

  // injecting lazily in order to avoid circular dependencies
}

